import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { APIResponseModel } from '../models/api-response-model';
import { ToastService } from './toast.service';

export interface BulkDownloadRequest {
  pageName: string;
  identifier1?: string;
  identifier2?: string;
  files: string[];
}

export interface BulkDownloadJobStatus {
  id: number;
  status: string;
  totalFiles: number;
  processedFiles: number;
  outputFileName?: string;
  errorMessage?: string;
  dateCreated: string;
  dateUpdated?: string;
  dateExpired?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BulkDownloadService extends BaseService {

  constructor(http: HttpClient, private toastService: ToastService) {
    super(http, 'documents');
  }

  createJob(request: BulkDownloadRequest): Observable<APIResponseModel<BulkDownloadJobStatus>> {
    return this.http.post<APIResponseModel<BulkDownloadJobStatus>>(`${this.baseUrl}/bulk-download`, request)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return this.httpErrorHandler(err, {});
        })
      );
  }

  getJobStatus(id: number): Observable<APIResponseModel<BulkDownloadJobStatus>> {
    return this.http.get<APIResponseModel<BulkDownloadJobStatus>>(`${this.baseUrl}/bulk-download/job-status/${id}`)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return this.httpErrorHandler(err, {});
        })
      );
  }

  downloadOutputFile(id: number, fileName: string) {
    this.http.get(`${this.baseUrl}/bulk-download/${id}`, {
      responseType: 'blob'
    })
    .pipe(
      catchError((err: HttpErrorResponse) => {
        return this.httpErrorHandler(err, {});
      })
    )
    .subscribe((res: any) => {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(res);
      a.download = fileName;
      a.click();
    });
  }

  downloadIfReady(id?: number): void {
    if (!id) {
      return;
    }

    this.getJobStatus(id).subscribe((response: any) => {
      if (response.isError || !response.data?.outputFileName) {
        this.toastService.error('Error', 'The requested file is no longer available to download.');
        return;
      }

      this.downloadOutputFile(id, response.data.outputFileName);
    });
  }
}
